import {DLMLabellingListFilter} from './DLMLabellingListFilter'

const DLMLabellingListToolbar = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-dlminspection-table-toolbar='base'>      
      <DLMLabellingListFilter />            
    </div>
  )
}

export {DLMLabellingListToolbar}
